export function featureExplanations() {
    const panel = document.getElementById('explanations');
    if (!panel) return;

    const closeTriggers = panel.querySelectorAll(
        '#explanations-toggle, #explanations-close',
    );
    const body = document.body;
    const html = document.documentElement;

    if (!closeTriggers.length) return;

    const wrapper = panel.querySelector('.feature-explanations__wrapper');

    const isSubMenuOpen = () =>
        [...document.querySelectorAll('.submenu')].some((subMenu) =>
            subMenu.classList.contains('open'),
        );

    const lockScroll = () => {
        if (body.dataset.featureExplanationsScrollLocked === 'true') return;

        body.dataset.featureExplanationsScrollLocked = 'true';
        html.classList.add('no-scroll');
        body.style.overflow = 'hidden';
        body.style.overscrollBehavior = 'none';
    };

    const unlockScroll = () => {
        if (body.dataset.featureExplanationsScrollLocked !== 'true') return;

        body.dataset.featureExplanationsScrollLocked = 'false';
        html.classList.remove('no-scroll');
        body.style.overflow = '';
        body.style.overscrollBehavior = '';
    };

    const open = (slug = '') => {
        panel.classList.add('active');
        body.classList.add('add-overlay');
        lockScroll();

        if (!slug) return;

        setTimeout(() => {
            const item = panel.querySelector(
                `[data-feature-slug="${CSS.escape(slug)}"]`,
            );

            if (!item || !wrapper) return;

            const heading = item.querySelector('.js-toggle');
            if (heading && !heading.classList.contains('active')) {
                heading.click();
            }

            const top =
                item.getBoundingClientRect().top -
                wrapper.getBoundingClientRect().top +
                wrapper.scrollTop;

            wrapper.scrollTo({
                top: Math.max(0, top - 16),
                behavior: 'smooth',
            });
        }, 400);
    };

    const close = () => {
        if (!panel.classList.contains('active')) return;

        panel.classList.remove('active');
        unlockScroll();

        if (!isSubMenuOpen()) {
            body.classList.remove('add-overlay');
        }
    };

    document.querySelectorAll('.side-button').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            open();
        });
    });

    closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            close();
        });
    });

    document.addEventListener(
        'click',
        (e) => {
            const trigger = e.target.closest('.feature-explanation-trigger');
            if (trigger) {
                e.preventDefault();
                open(trigger.dataset.featureSlug || '');
                return;
            }

            if (
                !panel.classList.contains('active') ||
                panel.contains(e.target) ||
                e.target.closest('.side-button')
            ) {
                return;
            }

            e.preventDefault();
            close();
        },
        true,
    );

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
    });
}
